import type { GenericParameters } from "~/core/models/GenericParameters.type";
import LxcError from "~/core/models/LxcError.class";
import type { RelationReferentUser } from "~/modules/relation/models/RelationReferentUser.interface";
import relationService from "~/modules/relation/service/relation.service";

export function useGetReferentUser(params: GenericParameters) {
  let service =
    relationService.getBusinessUnitReferentUser.bind(relationService);

  if (params.organizationCode) {
    service = relationService.getOrganizationReferentUser.bind(relationService);
  }

  const isLoading: Ref<boolean> = ref(false);
  const error: Ref<LxcError | undefined> = ref();
  const result: Ref<RelationReferentUser | undefined> = ref();

  async function getReferentUser(): Promise<void> {
    isLoading.value = true;
    error.value = undefined;
    result.value = undefined;

    const response = await service(params);
    if (LxcError.check(response)) {
      error.value = response;
    } else {
      result.value = response;
    }

    isLoading.value = false;
  }

  return {
    getReferentUser,
    isLoading,
    error,
    result,
  };
}
